import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  Inject,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { QuestionManagementService } from '../../../Services/question-management/question-management.service';
import { AddQuestionModel } from 'src/app/Models/AddQuestion';
import { AddQuestionByIDModel } from 'src/app/Models/AddQuestionByID';
import { QuestionStatusModel } from 'src/app/Models/QuestionStatusById';
import { AnswerChoiceModel } from 'src/app/Models/AnswerChoiceModel';
import { ToastrService } from 'ngx-toastr';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { VAddQuestion } from 'src/app/Validators/Validators';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import Quill from 'quill';
// import { runInThisContext } from 'vm';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import {
  IBreadCrumbSubject,
  IDropdownListCode,
  IFlashcard,
  ISubject,
} from './interface/falshcard.interface';
import { forkJoin } from 'rxjs';
import { AddEditFlashManagementService } from './services/add-edit.flash-management.service';
import { UserAuthDetails } from 'src/app/Services/user-sessions/user-auth-details';
import { AppOfflineStore } from 'src/app/app.offlineService';
import { IRelocateFlashcardPayload } from '../relocate-question/interfaces/flashcard.interface';
import { SubjectManagmentService } from 'src/app/Services/subject-management/subject-management.service';

import { delay, filter, map } from 'rxjs/operators';
import {
  imageUploadFlagEvent,
  imageUploadSubject,
} from '../service/image-upload-event';
import { environment } from 'src/environments/environment';
import {
  flashcardTinyMceOptionFront,
  flashcardTinyMceOptionBack,
} from './tinymce.option';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FlashcardAssignModalComponent } from './flashcard-assign-modal/flashcard-assign-modal.component';
import { ConfirmationModalComponent } from 'src/app/common/confirmation-modal/confirmation-modal.component';
import { ModalService } from 'src/app/Services/confirmation-modal/modalServie.service';
import { NotificationAddEditComponent } from '../../notification-management/notification-add-edit/notification-add-edit.component';
declare var DataTable: any;
@Component({
  selector: 'app-fa-question-add-edit',
  templateUrl: './question-add-edit.component.html',
  styleUrls: ['./question-add-edit.component.css'],
})
export class QuestionAddEditComponent implements OnInit {
  @Input() public subjectById: ISubject;
  @Input() public flashCardId: string;
  @Input() public globalFlashCardList: Array<IFlashcard>;
  @Input() set closeEventTriggerFa(value: object | null) {
    if (!value) return;
    this.clear();
  }

  @Output() closeFaDialog = new EventEmitter();
  public difficultyTypeList: Array<IDropdownListCode>;
  public courseCategoryType: Array<IDropdownListCode>;
  public flashCardStatusType: Array<IDropdownListCode>;
  public relocateFlashcard: boolean;
  @ViewChild('elemPreviewFront') elemPreviewFront: ElementRef;
  @ViewChild('elemPreviewBack') elemPreviewBack: ElementRef;
  @ViewChild('voidDum') voidElem: ElementRef;
  imageUploadingEventFlag: boolean = false;
  private interval$: any;
  public pagination = {
    currentPos: 0,
    len: 0,
    preBtnDis: false,
    nxtBtnDis: false,
  };

  public addEditFormGroup = new FormGroup({
    TestedConceptDifficultyLevel: new FormControl('', ),
    ApplicableFor: new FormArray([]),
    FrontText: new FormControl(),
    BackText: new FormControl(),
    FlashCardStatusType: new FormControl('', [Validators.required]),
  });

  createBy = '';
  createDate = '';
  updatedBy = '';
  updatingDate = '';

  imageListFrontSide: Array<typeof Image> = [];
  imageListBackSide: Array<typeof Image> = [];

  private userId: string = '';

  // sampleSubject: ISubject = {
  //   Subject_Id: 200195,
  //   Subject_Short_Code: 'PHY',
  //   Parent_Subject_Id: 200044,
  //   Subject_Name: 'Introduction',
  //   Subject_Level_Type_Code: 'SCL1',
  //   Subject_Status_Type_Code: 'Developing',
  //   Language_Ind: 'N',
  //   Display_Order: 1,
  //   Description_text: null,
  //   Language_Type_Code: '',
  //   Translated_Subject_Name: '',
  //   Translated_Subject_Subject_Status_Type_Code: '',
  //   Show_English_Name_Ind: '',
  // };

  public tinyMceOptionFront: Object = flashcardTinyMceOptionFront;
  public tinyMceOptionBack: Object = flashcardTinyMceOptionBack;

  public breadCrumbList: Array<IBreadCrumbSubject>;

  constructor(
    public service: QuestionManagementService,
    private readonly addEditFlashManagementService: AddEditFlashManagementService,
    private readonly fb: FormBuilder,
    private readonly toaster: ToastrService,
    public subjectMntService: SubjectManagmentService,
    private readonly appser: AppOfflineStore,
    private modalService: NgbModal,
    private modService: ModalService
  ) {
    imageUploadSubject.pipe(delay(2000)).subscribe((elem) => {
      this.imageOptimize('FrontText', elem.url, elem.height, elem.width);
      this.imageOptimize('BackText', elem.url, elem.height, elem.width);
    });
  }

  ngOnInit() {
    // this.subjectById = this.sampleSubject;

    this.getFlashcardsBySubjectId();
    this.getFlashcardDetails();
    imageUploadFlagEvent.subscribe((flag) => {
      this.imageUploadingEventFlag = flag;
    });
  }

  AssignFlashCard() {
    const modalRef = this.modalService.open(FlashcardAssignModalComponent, {
      backdrop: 'static',
      keyboard: false,
      scrollable: true,
      windowClass: 'custom-modal-width',
      backdropClass: 'light-blue-backdrop',
    });
    modalRef.componentInstance.isEdit = true;
    modalRef.componentInstance.SubjectId = this.subjectById?.Subject_Id;
    modalRef.componentInstance.FlashcardId = this.flashCardId ?? null;
    modalRef.componentInstance.ScreenName = 'ASSIGN_FLASHCARD_TO_COURSE';
  }

  imageOptimize(
    controlName: string,
    url: string,
    height: number,
    width: number
  ) {
    if (url.startsWith('https')) {
      url = url.replace(environment.apiBaseUrl, '');
    }
    let htmlString = this.addEditFormGroup.value[controlName] || '';

    // Use a regular expression to find and replace the <img> tag
    let regexSource = `<img([^>]*) src="${url}"([^>]*)>`;
    let dynamicRegex = new RegExp(regexSource, 'g');

    function resizeImage(
      originalWidth: number,
      originalHeight: number
    ): { width: number; height: number } {
      const maxWidth = 760;
      const maxHeight = 507;

      // Case 1: No resizing needed
      if (originalWidth <= maxWidth && originalHeight <= maxHeight) {
        return { width: originalWidth, height: originalHeight };
      }

      let newWidth, newHeight;

      // Calculate proportional resizing to fit within maxWidth and maxHeight
      const widthRatio = maxWidth / originalWidth;
      const heightRatio = maxHeight / originalHeight;
      const ratio = Math.min(widthRatio, heightRatio);

      newWidth = originalWidth * ratio;
      newHeight = originalHeight * ratio;

      return { width: newWidth, height: newHeight };
    }

    // Example usage:
    const originalWidth = width;
    const originalHeight = height;
    const resizedDimensions = resizeImage(originalWidth, originalHeight);

    let modifiedHtmlString = htmlString.replace(
      dynamicRegex,
      `<img$1 src="${url}"$2 width="${Math.floor(
        resizedDimensions.width
      )}" height="${Math.floor(resizedDimensions.height)}">`
    );

    this.addEditFormGroup.get(controlName)?.setValue(modifiedHtmlString);

    if (controlName === 'FrontText') {
      this.imageListFrontSide = this.parseHtmlFromStr(modifiedHtmlString);
    } else {
      this.imageListBackSide = this.parseHtmlFromStr(modifiedHtmlString);
    }
  }

  getFlashcardsBySubjectId() {
    if (!this.globalFlashCardList?.length) return;
    const currentIndex = this.globalFlashCardList.findIndex(
      (accu) => accu.FlashCard_ID === this.flashCardId
    );
    this.pagination = {
      currentPos: currentIndex,
      len: this.globalFlashCardList.length,
      nxtBtnDis:
        currentIndex === this.globalFlashCardList.length - 1 ? true : false,
      preBtnDis: currentIndex === 0 ? true : false,
    };

    if (this.pagination.currentPos <= 0) {
      // this.toaster.warning('First flashcard reached', '', {
      //   timeOut: 1000,
      // });
    }
    if (this.pagination.currentPos >= this.pagination.len - 1) {
      // this.toaster.warning('Last flashcard reached', '', {
      //   timeOut: 1000,
      // });
    }

    console.log(this.pagination);
  }

  getFlashcardDetails() {
    if (this.flashCardId) {
      this.addEditFlashManagementService
        .getFlashcard({
          LoggedInUser: UserAuthDetails.getUserLoggedInId(),
          SessionLanguageTypeCode: null,
          SubjectID: null,
          FlashCardID: this.flashCardId,
          FromDate: null,
          ToDate: null,
          FlashCardStatus: null,
          FlashCardKeyword1: null,
          Operator: null,
          FlashCardKeyword2: null,
          OwnFlashCardInd: null,
          ScreenName: 'ASSIGN_FLASHCARD_TO_COURSE',
        })
        .subscribe((elem) => {
          this.getSubjectById(elem.Subject_Id);
        });
    } else {
      this.getSubjectById(this.subjectById?.Subject_Id);
    }
  }

  ngAfterViewInit() {}

  getSubjectById(subjectId: number) {
    this.service
      .getsubjectById({
        CurrentNodeSubjectID: Number(subjectId),
      })
      .subscribe((subjectFromFlashcard: ISubject) => {
        this.subjectById = subjectFromFlashcard;

        this.retrieveLoggedInUserId();
        this.getBreadCrumbDetails();
        this.getDropdownList();
      });
  }

  retrieveLoggedInUserId() {
    const loggedInUserId = UserAuthDetails.getUserLoggedInId();

    if (!loggedInUserId)
      return this.toaster.error('Please Provide Logged in User Id', 'Error', {
        timeOut: 5000,
      });

    this.userId = loggedInUserId;
    return null;
  }

  getBreadCrumbDetails() {
    this.service
      .getBreadcrumbDetails({ ID: this.subjectById?.Subject_Id })
      .subscribe((breadCrumbSubject: Array<IBreadCrumbSubject>) => {
        this.breadCrumbList = breadCrumbSubject;
      });
  }

  getDropdownList() {
    forkJoin(
      this.addEditFlashManagementService.getDropdownList<
        Array<IDropdownListCode>
      >('CONCEPT_DIFFICULTY_LEVEL_TYPE'),
      this.addEditFlashManagementService.getDropdownList<
        Array<IDropdownListCode>
      >('COURSE_CATEGORY_TYPE'),
      this.addEditFlashManagementService.getDropdownList<
        Array<IDropdownListCode>
      >('FLASHCARD_STATUS_TYPE')
    ).subscribe((elem) => {
      const [difficultyTypeList, courseCategoryType, flashCardStatusType] =
        elem;

      this.difficultyTypeList = difficultyTypeList;
      this.courseCategoryType = courseCategoryType;
      this.flashCardStatusType = flashCardStatusType;

      this.getApplicableFor()?.clear();
      this.courseCategoryType.forEach((ct) => {
        this.getApplicableFor().push(this.addApplicableFor(ct));
      });

      if (!this.flashCardId) return;

      this.getFlashcard();
    });
  }

  getFlashcard() {
    forkJoin(
      this.addEditFlashManagementService.getFlashcard({
        LoggedInUser: this.userId,
        SessionLanguageTypeCode: this.appser.userlanuage,
        SubjectID: this.subjectById?.Subject_Id,
        FlashCardID: this.flashCardId,
        FromDate: null,
        ToDate: null,
        FlashCardStatus: null,
        FlashCardKeyword1: null,
        Operator: null,
        FlashCardKeyword2: null,
        OwnFlashCardInd: null,
        ScreenName: 'ASSIGN_FLASHCARD_TO_COURSE',
      }),
      // this.addEditFlashManagementService.getFlashcardUsage(
      //   this.userId,
      //   this.flashCardId
      // )
    ).subscribe((elem) => {
      const [flashcardDetails, ] = elem;

      // (flashCardUsage || []).forEach((fcu) => {
      //   const index = this.getApplicableFor()?.controls?.findIndex(
      //     (ap) => ap?.value?.Code === fcu?.Course_Category_Type_Code
      //   );
      //   if (index < 0) return;
      //   this.getApplicableFor()?.at(index).get('Selected')?.setValue(true);
      //   this.getApplicableFor()
      //     ?.at(index)
      //     .get('SelectedInitial')
      //     ?.setValue(true);
      // });

      this.addEditFormGroup.patchValue({
        TestedConceptDifficultyLevel:
          flashcardDetails.Concept_Difficulty_Level_Type_Code,
        FrontText: flashcardDetails.Front_Side_Text,
        BackText: flashcardDetails.Back_Side_Text,
        FlashCardStatusType: flashcardDetails.Flashcard_Status_Type_Code,
      });

      this.createBy = flashcardDetails.Created_By;
      this.createDate = flashcardDetails.Creation_Date;
      this.updatedBy = flashcardDetails.Updated_By;
      this.updatingDate = flashcardDetails.Updation_Date;

      this.refreshItem(this.elemPreviewFront.nativeElement, 'FrontText');
      this.refreshItem(this.elemPreviewBack.nativeElement, 'BackText');

      this.imageListFrontSide = this.parseHtmlFromStr(
        flashcardDetails.Front_Side_Text || ''
      );
      this.imageListBackSide = this.parseHtmlFromStr(
        flashcardDetails.Back_Side_Text || ''
      );
      // this.refreshItem;
    });
  }

  getApplicableFor() {
    return this.addEditFormGroup.get('ApplicableFor') as FormArray;
  }

  addApplicableFor(val: IDropdownListCode) {
    return this.fb.group({
      ...val,
      Selected: new FormControl(false),
      SelectedInitial: new FormControl(false),
    });
  }

  getLabelName(item: AbstractControl) {
    const { Description } = item.value as IDropdownListCode;
    return Description;
  }

  submitForm(bool = false) {
    return new Promise((resolve, reject) => {
      if (this.addEditFormGroup.invalid) {
        this.addEditFormGroup.markAllAsTouched();
        this.toaster.warning('Please Fill Required felids...', '', {
          timeOut: 500,
        });
        return;
      }

      // const udt = this.addEditFormGroup.value.ApplicableFor.filter(
      //   (accu: { Selected: boolean }) => accu.Selected
      // ).length;

      // if (!udt) {
      //   this.toaster.warning('Please Fill Applicable to felid', '', {
      //     timeOut: 500,
      //   });
      //   return;
      // }

      this.checkingDeletionValues();

      if (this.flashCardId) {
        // Edit Mode
        this.addEditFlashManagementService
          .updateFlashcard({
            LoggedInUser: this.userId,
            FlashCardID: this.flashCardId,
            SubjectID: this.subjectById?.Subject_Id,
            SubjectShortCode: this.subjectById?.Subject_Short_Code,
            // ConceptDifficultyLevelTypeCode:
            //   this.addEditFormGroup.value.TestedConceptDifficultyLevel,
            FrontSideText: this.addEditFormGroup.value.FrontText || '',
            BackSideText: this.addEditFormGroup.value.BackText || '',
            LanguageTypeCode: this.appser.userlanuage,
            FlashCardStatusTypeCode:
              this.addEditFormGroup.value.FlashCardStatusType,
            LanguageInd: this.subjectById?.Language_Ind,
            // UDTFlashCardUsage: this.addEditFormGroup.value.ApplicableFor.map(
            //   (ap: {
            //     Code: string;
            //     Selected: boolean;
            //     SelectedInitial: boolean;
            //   }) => {
            //     if (ap.Selected || ap.SelectedInitial) {
            //       return {
            //         value: ap.Code,
            //         markToDelete: this.getSelective(
            //           ap.SelectedInitial,
            //           ap.Selected
            //         ),
            //       };
            //     }

            //     return null;
            //   }
            // ).filter((accu: object) => accu),
          })
          .subscribe((elem) => {
            this.flashCardId = (
              elem as unknown as { NewFlashCardId: string }
            ).NewFlashCardId;
            this.toaster.success('Saved Successfully', 'Success', {
              timeOut: 500,
            });
            this.CreateNotification()
            this.addEditFormGroup.markAsPristine();
            this.addEditFormGroup.markAsUntouched();
            // if (bool) {
            //   this.closeFaDialog.emit();
            // }

            resolve(null);
          });
      } else if (!this.flashCardId) {
        // Save Mode

        this.addEditFlashManagementService
          .createFlashcard({
            LoggedInUser: this.userId,
            SubjectID: this.subjectById?.Subject_Id,
            SubjectShortCode: this.subjectById?.Subject_Short_Code,
            // ConceptDifficultyLevelTypeCode:
            //   this.addEditFormGroup.value.TestedConceptDifficultyLevel,
            FrontSideText: this.addEditFormGroup.value.FrontText || '',
            BackSideText: this.addEditFormGroup.value.BackText || '',
            LanguageTypeCode: this.appser.userlanuage,
            FlashCardStatusTypeCode:
              this.addEditFormGroup.value.FlashCardStatusType,
            LanguageInd: this.subjectById?.Language_Ind,
          })
          .subscribe((elem) => {
            this.flashCardId = (
              elem as unknown as { NewFlashCardId: string }
            ).NewFlashCardId;

            this.toaster.success('Saved Successfully', 'Success',{timeOut: 500});
            this.CreateNotification()
            this.addEditFormGroup.markAsPristine();
            this.addEditFormGroup.markAsUntouched();

            // if (bool) {
            //   this.closeFaDialog.emit(true);
            // }

            resolve(null);
          });
      }
    });
  }

    async CreateNotification(): Promise<boolean> {
      try {
        // Step 1: Ask for confirmation
        const result = await this.modService.open(
          'Confirmation',
          'Do you want to send notification to all the users about this FlashCard?',
          'Yes',
          'No'
        );

        if (!result) {
          return false; // user cancelled
        }

        // Step 2: Open notification modal
        const modalRef = this.modalService.open(NotificationAddEditComponent, {
          centered: true,
          size: 'xl',
          windowClass: 'custom-modal-width-notification-flashcard',
          backdropClass: 'custom-backdrop-notification'
        });

        // Pass data into modal
        modalRef.componentInstance.screenName = 'Flashcard';
        modalRef.componentInstance.MaterialId = this.flashCardId;

        // Step 3: Wait for modal close result
        const notificationResult = await modalRef.result
          .then((res: any) => res)
          .catch(() => false);

        return !!notificationResult;
      } catch (error) {
        console.error('CreateNotification dismissed or failed:', error);
        return false;
      }
    }

  getSelective(init: boolean, sel: boolean) {
    if (init && sel) {
      return false;
    } else if (init && !sel) {
      return true;
    } else if (!init && sel) {
      return false;
    }

    return null;
  }

  getError(formField: string) {
    return this.addEditFormGroup.get(formField)?.hasError('required') &&
      this.addEditFormGroup.get(formField)?.touched
      ? true
      : false;
  }

  relocate(evt: IRelocateFlashcardPayload) {
    if (!evt) {
      this.relocateFlashcard = false;
      return;
    }
    // idr a
    this.relocateFlashcard = false;
    this.getSubjectById(evt.ToSubjectId);
    this.clear(true)
  }

  closeEdit() {}

  async clear(reload=false) {
    if (this.addEditFormGroup.dirty) {
      // const flag = window.confirm('Do you want to save the changes');
      const result = await this.modService.open(
        'Confirmation',
        'Do you want to save the changes?'
      );

      if (result) {
        await this.submitForm(true);
        this.closeFaDialog.emit(true);
      } else {
        this.closeFaDialog.emit();
      }
    } else {
      // this.addEditExamCourseMaster.reset();
      // idr a
      this.closeFaDialog.emit(reload);
    }
  }

  refreshItem(elem: any, formControlName: string) {
    if (elem) {
      const textValue = this.addEditFormGroup.value[formControlName];

      elem.innerHTML = textValue;
    }
  }

  async paginate(type: string) {
    if (type === 'PRE') {
      if (this.pagination.currentPos <= 0) {
        this.toaster.warning('First flashcard reached', '', {
          timeOut: 500,
        });
        return;
      }
      this.pagination.currentPos = this.pagination.currentPos - 1;
    } else if (type === 'NXT') {
      if (this.pagination.currentPos >= this.pagination.len - 1) {
        this.toaster.warning('Last flashcard reached', '', {
          timeOut: 500,
        });
        return;
      }
      this.pagination.currentPos = this.pagination.currentPos + 1;
    }


    // call api
    if (this.addEditFormGroup.dirty) {
      // const flag = window.confirm('Do you want to save the changes');
      const result = await this.modService.open(
        'Confirmation',
        'Do you want to save the changes?'
      );

      if (result) {
        await this.submitForm();
      }
    }

    const flashCard = this.globalFlashCardList[this.pagination.currentPos];

    this.subjectById = {
      Subject_Id: flashCard.Subject_Id as number,
    } as ISubject;

    this.flashCardId = flashCard.FlashCard_ID;

    this.addEditFormGroup.reset();

    this.voidElem.nativeElement.click();
    this.ngOnInit();
  }

  DFS(stack: any, list: any): any {
    try {
      if (!stack.length) return list;
      const elem = stack.pop();
      const cn = Object.values(elem?.childNodes || {});
      cn.length ? stack.push(...cn) : list.push(elem);
      return this.DFS(stack, list);
    } catch (err) {
      return [];
    }
  }

  parseHtmlFromStr(html: string) {
    try {
      const parser = new DOMParser();
      const dom = parser.parseFromString(html, 'text/html');
      return this.DFS(Object.values(dom.childNodes), [])
        .filter((accu: any) => accu instanceof Image)
        .map((accu: any) => {
          if ((accu?.src || '')?.startsWith('base')) return null;
          return {
            src: accu.src,
          };
        })
        .filter((accu: any) => accu);
    } catch (err) {
      return [];
    }
  }

  deleteImage(url: string[]) {
    // console.log(url, ' Deleted');

    try {
      url.forEach((str) => {
        const hash = str.split('/');
        this.addEditFlashManagementService
          .deleteImageFromTextEditor(hash[hash.length - 1])
          .subscribe();
      });
    } catch (err) {}
  }

  checkingDeletionValues() {
    try {
      const currentElemF = this.parseHtmlFromStr(
        this.addEditFormGroup.value.FrontText
      );
      const currentElemB = this.parseHtmlFromStr(
        this.addEditFormGroup.value.BackText
      );

      const dItemF = this.imageListFrontSide.filter((accu: any) => {
        return !currentElemF.find((_accu: any) => _accu?.src === accu?.src);
      });
      const dItemB = this.imageListBackSide.filter((accu: any) => {
        return !currentElemB.find((_accu: any) => _accu?.src === accu?.src);
      });

      if (dItemF.length) {
        this.imageListFrontSide = currentElemF;
      }
      if (dItemB.length) {
        this.imageListBackSide = currentElemB;
      }
      // console.log(dItem, this.imageListFrontSide);
      this.deleteImage([...dItemF, ...dItemB].map((accu: any) => accu.src));
      // console.log('counter is Checking');
    } catch (err) {}
  }

  ngOnDestroy() {
    console.log('Component destory');

    if (this.interval$) {
      clearInterval(this.interval$);
    }
  }
}
